import CardSystem from '../CardSystem';
import { CardTask } from '../../../State/Card/CardTasks';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

import FlipCardAnimation from '../Animations/FlipCardAnimation';
import RemoveThreePreBoosterAnimation from '../Animations/RemoveThreePreBoosterAnimation';
import RevealCanisterPreBoosterAnimation from '../Animations/RevealCanisterPreBoosterAnimation';
import RevealJokerPreBoosterAnimation from '../Animations/RevealJokerPreBoosterAnimation';
import ReceiveJokerPreBoosterAnimation from '../Animations/ReceiveJokerPreBoosterAnimation';
import UseCanisterPreBoosterAnimation from '../Animations/UseCanisterPreBoosterAnimation';
import UndoFlipCardAnimation from '../Animations/UndoFlipCardAnimation';
import RockCardAnimation from '../Animations/rockCardAnimation';
import BombCardAnimation from '../Animations/BombCardAnimation';
import BoomCardAnimation from '../Animations/BoomCardAnimation';
import BullsEyeCardAnimation from '../Animations/BullsEyeCardAnimation';
import FogEndCardAnimation from '../Animations/FogEndCardAnimation';
import FoldCardAnimation from '../Animations/FoldCardAnimation';
import IceCardAnimation from '../Animations/IceCardAnimation';
import JokerCardAnimation from '../Animations/JokerCardAnimation';
import KeyCardAnimation from '../Animations/KeyCardAnimation';
import MatchCardAnimation from '../Animations/MatchCardAnimation';
import PlusFiveCardAnimation from '../Animations/PlusFiveCardAnimation';
import PlusOneCardAnimation from '../Animations/PlusOneCardAnimation';
import PlusStreakCardAnimation from '../Animations/PlusStreakCardAnimation';
import PlusStreakJokerCardAnimation from '../Animations/PlusStreakJokerCardAnimation';
import PlusThreeCardAnimation from '../Animations/PlusThreeCardAnimation';
import ScissorsCardAnimation from '../Animations/ScissorsCardAnimation';
import ShuffleCardAnimation from '../Animations/ShuffleCardAnimation';
import TntCardAnimation from '../Animations/TntCardAnimation';
import TornadoCardAnimation from '../Animations/TornadoCardAnimation';
import UndoFoldCardAnimation from '../Animations/UndoFoldCardAnimation';
import UndoMatchCardAnimation from '../Animations/UndoMatchCardAnimation';
import WiggleCardAnimation from '../Animations/WiggleCardAnimation';
import ZapCardAnimation from '../Animations/ZapCardAnimation';
import EarlyRemoveThreePreBoosterTask from '../Animations/earlyRemoveThreePreBoosterTask';
import MatchConnectedCardAnimation from '../Animations/matchConnectedCardAnimation';
import ReceivePlinkoCardAnimation from '../Animations/ReceivePlinkoCardAnimation';

export default class CardStateAnimationHelper {
    public static handleEarlyTask(system: CardSystem, taskData: ICardStateTaskData) {
        switch (taskData.task) {
            case CardTask.REMOVE_THREE_PRE_BOOSTER:
                return EarlyRemoveThreePreBoosterTask(system, taskData);
        }
    }

    public static handleTask(system: CardSystem, taskData: ICardStateTaskData) {
        switch (taskData.task) {
            case CardTask.FOLD:
                return FoldCardAnimation(system, taskData);
            case CardTask.MATCH:
                return MatchCardAnimation(system, taskData);
            case CardTask.MATCH_CONNECTED_CARD:
                return MatchConnectedCardAnimation(system, taskData);
            case CardTask.FLIP:
                return FlipCardAnimation(system, taskData);
            case CardTask.WIGGLE:
                return WiggleCardAnimation(system, taskData);
            case CardTask.ZAP:
                return ZapCardAnimation(system, taskData);
            case CardTask.BOOM:
                return BoomCardAnimation(system, taskData);
            case CardTask.BOMB:
                return BombCardAnimation(system, taskData);
            case CardTask.ICE:
                return IceCardAnimation(system, taskData);
            case CardTask.SCISSOR:
                return ScissorsCardAnimation(system, taskData);
            case CardTask.KEY:
                return KeyCardAnimation(system, taskData);
            case CardTask.PLUS_THREE:
                return PlusThreeCardAnimation(system, taskData);
            case CardTask.TORNADO:
                return TornadoCardAnimation(system, taskData);
            case CardTask.FOG_END:
                return FogEndCardAnimation(system, taskData);
            case CardTask.ROCK:
                return RockCardAnimation(system, taskData);
            case CardTask.PLUS_FIVE:
                return PlusFiveCardAnimation(system, taskData);
            case CardTask.PLUS_ONE:
                return PlusOneCardAnimation(system, taskData);
            case CardTask.PLUS_STREAK:
                return PlusStreakCardAnimation(system, taskData);
            case CardTask.PLUS_STREAK_JOKER:
                return PlusStreakJokerCardAnimation(system, taskData);
            case CardTask.UNDO_MATCH:
                return UndoMatchCardAnimation(system, taskData);
            case CardTask.UNDO_FOLD:
                return UndoFoldCardAnimation(system, taskData);
            case CardTask.SHUFFLE:
                return ShuffleCardAnimation(system, taskData);
            case CardTask.TNT:
                return TntCardAnimation(system, taskData);
            case CardTask.BULLS_EYE:
                return BullsEyeCardAnimation(system, taskData);
            case CardTask.JOKER:
                return JokerCardAnimation(system, taskData);
            case CardTask.REMOVE_THREE_PRE_BOOSTER:
                return RemoveThreePreBoosterAnimation(system, taskData);
            case CardTask.REVEAL_CANISTER_PRE_BOOSTER:
                return RevealCanisterPreBoosterAnimation(system, taskData);
            case CardTask.USE_CANISTER_PRE_BOOSTER:
                return UseCanisterPreBoosterAnimation(system, taskData);
            case CardTask.REVEAL_JOKER_PRE_BOOSTER:
                return RevealJokerPreBoosterAnimation(system, taskData);
            case CardTask.RECEIVE_JOKER_PRE_BOOSTER:
                return ReceiveJokerPreBoosterAnimation(system, taskData);
            case CardTask.UNDO_FLIP:
                return UndoFlipCardAnimation(system, taskData);
            case CardTask.RECEIVE_PLINKO_CARD:
                return ReceivePlinkoCardAnimation(system, taskData);
        }
    }
}
